





















































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { RequestsService } from "@/services/requests.service";
import { LoginService } from "@/services/login.service.ts";

import LoginBox from "@/views/components/LoginBox.vue";
import { MESSAGE } from "@/models/Message";
import { CommonService } from '@/services/Common.service';

export interface Staffs {
  kyotenCd: string;
  kyotenNm: string;
  staffCd: string;
  staffNm: string;
}

@Component({
  components: {
    LoginBox
  }
})
export default class LoginStaff extends Vue {
  @Action("setStaffData", { namespace: "AuthStore" })
  public setStaffData: any;

  @Action("setEnvironment",  { namespace: "EnvironmentStore" })
  public setEnvironment: any;

  // public form = {
  //   username: '',
  //   password: '',
  // };

  public onShow: boolean = false;
  public reqService: any;
  public loginService: any = new LoginService();
  public staffData: Staffs[] = [];
  public staffSelected: Staffs = {
    kyotenCd: "",
    kyotenNm: "",
    staffCd: "",
    staffNm: ""
  };
  public errorMsg: string = "";
  commonService: CommonService = new CommonService();

  constructor() {
    super();
    this.reqService = new RequestsService();
  }

  public async getStaff() {
    const { result, error } = await this.reqService.getStaff();
    if (result) {
      this.$set(this, "staffData", [...result]);
    } else if (error) {
      console.log("getStaff[ERROR]", error);
    }
  }

  public async onSubmit(formData: any) {
    const response = await this.loginService.loginStaff(formData);
    if (response.result) {
      if (response.result.results) {
        this.loginService.shakenInitial();
        const data = { ...response.result, ...this.staffSelected };
        this.$emit("onSubmitStaff", data);
        localStorage.setItem("staffData", JSON.stringify(data));
        this.setStaffData(data);
        let kyotenCd = localStorage.getItem("kyotenCd");
        if (kyotenCd) {
          const env = this.commonService.reqEnvironment(kyotenCd);
          this.setEnvironment(env);
        }
      } else {
        this.errorMsg = "ログイン情報に誤りがあります。";
      }
    } else if (response.error) {
      if (response.error.rsltComment && response.status < 500) {
        this.errorMsg = response.error.rsltComment;
      } else {
        this.errorMsg = MESSAGE.SystemError;
      }
    }
  }

  public selectStaff(event: any) {
    this.$set(this, "staffSelected", event);
  }

  private created() {
    // localStorage.removeItem('staffData');
    this.getStaff();
    // history.pushState('', 'Authen Staff', '/authenstaff');
  }
}
